(function () {

  var OVERLAY_ID = 'vg-overlay';
  var LIGHTBOX_ID = 'vg-lightbox';

  function detectThemeColor() {
    var btn = document.querySelector(
      'button[type="submit"], .btn, .product-form__cart-submit, [name="add"], .btn--add-to-cart'
    );
    var color = '#1a1a1a';
    if (btn) {
      var bg = window.getComputedStyle(btn).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') color = bg;
    }
    document.documentElement.style.setProperty('--vg-theme-color', color);
  } 

  function injectStyles() {
    if (document.getElementById('vg-styles')) return;
    var style = document.createElement('style');
    style.id = 'vg-styles';
    style.textContent = [
      '#vg-overlay { display:none; width:100%; }',
      '#vg-overlay.vg-active { display:block; }',

      '#vg-main-wrap { width:100%; height:100%; overflow:hidden; position:relative; }',
      '#vg-main-wrap img#vg-main-img-el { width:100%; height:100%; object-fit:contain; display:block !important; opacity:1 !important; transition:none !important; }',

      '.vg-arrow { position:absolute; top:50%; transform:translateY(-50%); width:40px; height:40px; border-radius:50%; background:var(--vg-theme-color, #1a1a1a); color:#fff; border:none; display:flex; align-items:center; justify-content:center; cursor:pointer; z-index:5; opacity:0.9; }',
      '.vg-arrow:hover { opacity:1; }',
      '.vg-arrow svg { width:18px; height:18px; fill:#fff; }',
      '.vg-arrow--prev { left:12px; }',
      '.vg-arrow--next { right:12px; }',

      '.vg-zoom-btn { position:absolute !important; top:12px; right:12px; width:36px; height:36px; border-radius:50%; background:rgba(255,255,255,0.9); border:none; display:flex !important; align-items:center; justify-content:center; cursor:pointer; z-index:50; box-shadow:0 2px 6px rgba(0,0,0,0.15); pointer-events:auto; }',
      '.vg-zoom-btn svg { width:18px; height:18px; }',

      '#vg-thumbs { display:flex; gap:6px; padding:8px 0; flex-wrap:wrap; }',
      '#vg-thumbs .vg-t { width:72px; height:72px; cursor:pointer; border:2px solid #ddd; border-radius:4px; overflow:hidden; flex-shrink:0; }',
      '#vg-thumbs .vg-t img { width:100%; height:100%; object-fit:cover; display:block !important; opacity:1 !important; transition:none !important; }',
      '#vg-thumbs .vg-t.active { border-color:var(--vg-theme-color, #1a1a1a); }',

      '@media (max-width: 767px) {',
      '  #vg-main-wrap { display:none !important; }',
      '  #vg-thumbs { display:none !important; }',
      '  #vg-slider-wrap { display:block; width:100%; overflow:hidden; position:relative; touch-action:pan-y; }',
      '  #vg-slider-track { display:flex; height:auto; will-change:transform; }',
      '  #vg-slider-track .vg-slide { flex:0 0 78%; margin-right:10px; border-radius:12px; overflow:hidden; flex-shrink:0; position:relative; }',
      '  #vg-slider-track .vg-slide img { width:100%; height:auto; aspect-ratio:1/1; object-fit:contain; display:block !important; opacity:1 !important; transition:none !important; background:#f9f9f9; border-radius:12px; }',
      '  #vg-dots { display:flex; justify-content:center; gap:6px; padding:10px 0 4px; }',
      '  #vg-dots .vg-dot { width:7px; height:7px; border-radius:50%; background:#ddd; transition:background .2s, transform .2s; }',
      '  #vg-dots .vg-dot.active { background:var(--vg-theme-color, #1a1a1a); transform:scale(1.3); }',
      '  .vg-arrow { display:none; }',
      '}',

      '@media (min-width: 768px) {',
      '  #vg-slider-wrap { display:none !important; }',
      '  #vg-dots { display:none !important; }',
      '}',

      '#' + LIGHTBOX_ID + ' { position:fixed; inset:0; background:rgba(0,0,0,0.92); z-index:99999; display:none; align-items:center; justify-content:center; overflow:hidden; touch-action:none; }',
      '#' + LIGHTBOX_ID + '.vg-lb-active { display:flex; }',
      '#vg-lb-img-wrap { width:100%; height:100%; display:flex; align-items:center; justify-content:center; overflow:hidden; }',
      '#vg-lb-img { max-width:94%; max-height:94%; object-fit:contain; will-change:transform; touch-action:none; user-select:none; -webkit-user-drag:none; }',
      '#vg-lb-close { position:absolute; top:16px; right:16px; width:42px; height:42px; border-radius:50%; background:rgba(255,255,255,0.15); border:none; color:#fff; font-size:22px; cursor:pointer; z-index:2; }',
      '#vg-lb-controls { position:absolute; bottom:20px; left:50%; transform:translateX(-50%); display:flex; gap:10px; z-index:2; }',
      '#vg-lb-controls button { width:42px; height:42px; border-radius:50%; background:rgba(255,255,255,0.15); border:none; color:#fff; font-size:20px; cursor:pointer; }',
      '#vg-lb-hint { position:absolute; bottom:74px; left:50%; transform:translateX(-50%); color:rgba(255,255,255,0.6); font-size:12px; z-index:2; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  var CHEVRON_LEFT = '<svg viewBox="0 0 24 24"><path d="M15.5 4.5L8 12l7.5 7.5"/></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24"><path d="M8.5 4.5L16 12l-7.5 7.5"/></svg>';
  var ZOOM_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M11 8v6M8 11h6"/></svg>';

  function iconStroke(svgStr) {
    return svgStr.replace('<svg ', '<svg fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" ');
  }

  function buildOverlay(container) {
    if (document.getElementById(OVERLAY_ID)) return;
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.innerHTML =
      '<div id="vg-main-wrap">' +
        '<img id="vg-main-img-el" src="" alt="">' +
        '<button class="vg-arrow vg-arrow--prev" type="button">' + iconStroke(CHEVRON_LEFT) + '</button>' +
        '<button class="vg-arrow vg-arrow--next" type="button">' + iconStroke(CHEVRON_RIGHT) + '</button>' +
        '<button class="vg-zoom-btn" id="vg-zoom-desktop" type="button">' + ZOOM_ICON + '</button>' +
      '</div>' +
      '<div id="vg-slider-wrap"><div id="vg-slider-track"></div></div>' +
      '<div id="vg-thumbs"></div>' +
      '<div id="vg-dots"></div>';
    container.insertBefore(overlay, container.firstChild);
    buildLightbox();
  }

  function buildLightbox() {
    if (document.getElementById(LIGHTBOX_ID)) return;
    var lb = document.createElement('div');
    lb.id = LIGHTBOX_ID;
    lb.innerHTML =
      '<button id="vg-lb-close" type="button">&times;</button>' +
      '<div id="vg-lb-img-wrap"><img id="vg-lb-img" src="" alt=""></div>' +
      '<div id="vg-lb-hint">Pinch or drag to zoom</div>' +
      '<div id="vg-lb-controls">' +
        '<button id="vg-lb-minus" type="button">&minus;</button>' +
        '<button id="vg-lb-reset" type="button">&#8635;</button>' +
        '<button id="vg-lb-plus" type="button">+</button>' +
      '</div>';
    document.body.appendChild(lb);
    initLightboxGestures();
  }

  var lbState = { scale: 1, x: 0, y: 0, startDist: 0, startScale: 1, isDragging: false, startX: 0, startY: 0, lastTapTime: 0 };

  function initLightboxGestures() {
    var lb = document.getElementById(LIGHTBOX_ID);
    var img = document.getElementById('vg-lb-img');
    var wrap = document.getElementById('vg-lb-img-wrap');
    var closeBtn = document.getElementById('vg-lb-close');
    var plusBtn = document.getElementById('vg-lb-plus');
    var minusBtn = document.getElementById('vg-lb-minus');
    var resetBtn = document.getElementById('vg-lb-reset');

    function applyTransform() {
      img.style.transform = 'translate(' + lbState.x + 'px,' + lbState.y + 'px) scale(' + lbState.scale + ')';
    }
    function resetZoom() { lbState.scale = 1; lbState.x = 0; lbState.y = 0; applyTransform(); }

    closeBtn.addEventListener('click', function () {
      lb.classList.remove('vg-lb-active');
      document.body.style.overflow = '';
      resetZoom();
    });
    plusBtn.addEventListener('click', function () { lbState.scale = Math.min(lbState.scale + 0.5, 4); applyTransform(); });
    minusBtn.addEventListener('click', function () {
      lbState.scale = Math.max(lbState.scale - 0.5, 1);
      if (lbState.scale === 1) { lbState.x = 0; lbState.y = 0; }
      applyTransform();
    });
    resetBtn.addEventListener('click', resetZoom);

    function dist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    wrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        lbState.startDist = dist(e.touches);
        lbState.startScale = lbState.scale;
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lbState.lastTapTime < 300) {
          if (lbState.scale > 1) resetZoom();
          else { lbState.scale = 2.5; applyTransform(); }
        }
        lbState.lastTapTime = now;
        lbState.isDragging = true;
        lbState.startX = e.touches[0].clientX - lbState.x;
        lbState.startY = e.touches[0].clientY - lbState.y;
      }
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        var newDist = dist(e.touches);
        var ratio = newDist / (lbState.startDist || newDist);
        lbState.scale = Math.min(Math.max(lbState.startScale * ratio, 1), 4);
        applyTransform();
      } else if (e.touches.length === 1 && lbState.isDragging && lbState.scale > 1) {
        lbState.x = e.touches[0].clientX - lbState.startX;
        lbState.y = e.touches[0].clientY - lbState.startY;
        applyTransform();
      }
    }, { passive: true });

    wrap.addEventListener('touchend', function () { lbState.isDragging = false; });

    var mouseDown = false;
    wrap.addEventListener('mousedown', function (e) {
      if (lbState.scale <= 1) return;
      mouseDown = true;
      lbState.startX = e.clientX - lbState.x;
      lbState.startY = e.clientY - lbState.y;
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseDown) return;
      lbState.x = e.clientX - lbState.startX;
      lbState.y = e.clientY - lbState.startY;
      applyTransform();
    });
    window.addEventListener('mouseup', function () { mouseDown = false; });

    wrap.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY < 0 ? 0.2 : -0.2;
      lbState.scale = Math.min(Math.max(lbState.scale + delta, 1), 4);
      if (lbState.scale === 1) { lbState.x = 0; lbState.y = 0; }
      applyTransform();
    }, { passive: false });
  }

  function openLightbox(imgUrl) {
    var lb = document.getElementById(LIGHTBOX_ID);
    var img = document.getElementById('vg-lb-img');
    img.src = imgUrl;
    lbState.scale = 1; lbState.x = 0; lbState.y = 0;
    img.style.transform = 'translate(0px,0px) scale(1)';
    lb.classList.add('vg-lb-active');
    document.body.style.overflow = 'hidden';
  }

  function initMobileSlider(total) {
    if (window.innerWidth >= 768) return;
    var track = document.getElementById('vg-slider-track');
    var sliderWrap = document.getElementById('vg-slider-wrap');
    var dotsContainer = document.getElementById('vg-dots');
    if (!track || !sliderWrap) return;

    var originalSlides = Array.from(track.querySelectorAll('.vg-slide'));
    if (originalSlides.length === 0) return;

    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    track.appendChild(firstClone);
    track.insertBefore(lastClone, originalSlides[0]);
    bindSlideZoom(track);

    var totalWithClones = total + 2;
    var currentIndex = 1;
    var slideWidth = 0;
    var isDragging = false;
    var startX = 0, startTranslate = 0, currentTranslate = 0, animationID = 0, velocity = 0, lastX = 0, lastTime = 0;

    function calcSlideWidth() { slideWidth = sliderWrap.offsetWidth * 0.78 + 10; }
    function getPositionX(e) { return e.touches ? e.touches[0].clientX : e.pageX; }

    function updateDots(realIndex) {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.vg-dot').forEach(function (d, i) { d.classList.toggle('active', i === realIndex); });
    }
    function realIndexFromCurrent() {
      if (currentIndex === 0) return total - 1;
      if (currentIndex === totalWithClones - 1) return 0;
      return currentIndex - 1;
    }
    function setPosition(animate) {
      var sideOffset = (sliderWrap.offsetWidth - (slideWidth - 10)) / 2;
      currentTranslate = -(currentIndex * slideWidth) + sideOffset;
      track.style.transition = animate ? 'transform 0.42s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
      updateDots(realIndexFromCurrent());
    }
    function goToIndex(index, animate) { currentIndex = index; setPosition(animate !== false); }
    function handleInfiniteJump() {
      if (currentIndex === totalWithClones - 1) setTimeout(function () { goToIndex(1, false); }, 430);
      if (currentIndex === 0) setTimeout(function () { goToIndex(total, false); }, 430);
    }

    track.addEventListener('touchstart', function (e) {
      isDragging = true;
      startX = getPositionX(e); lastX = startX; lastTime = Date.now();
      startTranslate = currentTranslate; velocity = 0;
      track.style.transition = 'none';
      cancelAnimationFrame(animationID);
      animationID = requestAnimationFrame(function loop() {
        if (isDragging) { track.style.transform = 'translateX(' + currentTranslate + 'px)'; animationID = requestAnimationFrame(loop); }
      });
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      var now = Date.now(); var posX = getPositionX(e);
      currentTranslate = startTranslate + (posX - startX);
      velocity = (posX - lastX) / (now - lastTime + 1) * 16;
      lastX = posX; lastTime = now;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      isDragging = false;
      cancelAnimationFrame(animationID);
      var movedBy = currentTranslate - startTranslate;
      if (velocity < -3 || movedBy < -(slideWidth * 0.2)) goToIndex(currentIndex + 1, true);
      else if (velocity > 3 || movedBy > (slideWidth * 0.2)) goToIndex(currentIndex - 1, true);
      else goToIndex(currentIndex, true);
      handleInfiniteJump();
    }, { passive: true });

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('div');
        dot.className = 'vg-dot' + (i === 0 ? ' active' : '');
        dotsContainer.appendChild(dot);
      }
    }

    calcSlideWidth();
    goToIndex(1, false);
  }

  function bindSlideZoom(scopeEl) {
    scopeEl.querySelectorAll('.vg-slide').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var existingBtn = slide.querySelector('.vg-zoom-btn');
      if (existingBtn) existingBtn.remove();
      var zoomBtn = document.createElement('button');
      zoomBtn.type = 'button';
      zoomBtn.className = 'vg-zoom-btn';
      zoomBtn.innerHTML = ZOOM_ICON;
      zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(img.src); });
      slide.appendChild(zoomBtn);
    });
  }

  var desktopState = { images: [], index: 0 };

  function showDesktopImage(i) {
    var mainImg = document.getElementById('vg-main-img-el');
    var thumbsContainer = document.getElementById('vg-thumbs');
    desktopState.index = ((i % desktopState.images.length) + desktopState.images.length) % desktopState.images.length;
    mainImg.src = desktopState.images[desktopState.index];
    thumbsContainer.querySelectorAll('.vg-t').forEach(function (t, idx) { t.classList.toggle('active', idx === desktopState.index); });
  }

  function initDesktopArrows() {
    var prevBtn = document.querySelector('.vg-arrow--prev');
    var nextBtn = document.querySelector('.vg-arrow--next');
    if (prevBtn && !prevBtn.dataset.bound) {
      prevBtn.dataset.bound = '1';
      prevBtn.addEventListener('click', function () { showDesktopImage(desktopState.index - 1); });
    }
    if (nextBtn && !nextBtn.dataset.bound) {
      nextBtn.dataset.bound = '1';
      nextBtn.addEventListener('click', function () { showDesktopImage(desktopState.index + 1); });
    }
    var zoomBtn = document.getElementById('vg-zoom-desktop');
    if (zoomBtn && !zoomBtn.dataset.bound) {
      zoomBtn.dataset.bound = '1';
      zoomBtn.addEventListener('click', function () { openLightbox(desktopState.images[desktopState.index]); });
    }
  }

  function showOverlay(variantId, galleryData, originalSlideshow, originalThumbs) {
    var images = galleryData[variantId];
    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    if (!images || images.length === 0) {
      overlay.classList.remove('vg-active');
      if (originalSlideshow) originalSlideshow.style.display = '';
      if (originalThumbs) originalThumbs.style.display = '';
      return;
    }

    if (originalSlideshow) originalSlideshow.style.display = 'none';
    if (originalThumbs) originalThumbs.style.display = 'none';
    overlay.classList.add('vg-active');

    var thumbsContainer = document.getElementById('vg-thumbs');
    var sliderTrack = document.getElementById('vg-slider-track');

    desktopState.images = images;
    desktopState.index = 0;
    showDesktopImage(0);
    initDesktopArrows();

    thumbsContainer.innerHTML = '';
    images.forEach(function (url, i) {
      var t = document.createElement('div');
      t.className = 'vg-t' + (i === 0 ? ' active' : '');
      t.innerHTML = '<img src="' + url + '" alt="">';
      t.addEventListener('click', function () { showDesktopImage(i); });
      thumbsContainer.appendChild(t);
    });

    sliderTrack.innerHTML = '';
    images.forEach(function (url) {
      var slide = document.createElement('div');
      slide.className = 'vg-slide';
      slide.innerHTML = '<img src="' + url + '" alt="">';
      sliderTrack.appendChild(slide);
    });
    bindSlideZoom(sliderTrack);

    setTimeout(function () { initMobileSlider(images.length); }, 50);

    console.log('[VG] Showing', images.length, 'images for variant:', variantId);
  }

  function init() {
    var dataScript = document.getElementById('variant-gallery-data');
    if (!dataScript) return;

    var galleryData = {};
    try { galleryData = JSON.parse(dataScript.textContent); } catch (e) { return; }

    var hasImages = Object.keys(galleryData).some(function (k) { return galleryData[k] && galleryData[k].length > 0; });
    if (!hasImages) return;

    detectThemeColor();
    injectStyles();

    // ---- NAYE THEME KE SELECTORS ----
    var container = document.querySelector('[data-product-single-media-group]');
    if (!container) return;

    var originalSlideshow = container.querySelector('.product-single__wrapper') || container.querySelector('.product-single__gallery');
    var originalThumbs = document.querySelector('.thumbnails-wrapper');

    buildOverlay(container);

    var variantScript = document.getElementById('current-variant-json-vg');
    if (variantScript) {
      try {
        var v = JSON.parse(variantScript.textContent);
        if (v && v.id) showOverlay(String(v.id), galleryData, originalSlideshow, originalThumbs);
      } catch (e) {}
    }

    var lastUrl = location.href;
    new MutationObserver(function () {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        var params = new URLSearchParams(window.location.search);
        var vid = params.get('variant');
        if (vid) showOverlay(vid, galleryData, originalSlideshow, originalThumbs);
      }
    }).observe(document, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();